module.exports = "/packs/008-1a5fe8a4c7a77207d7677619d75682dd.jpg";